import { render, staticRenderFns } from "./AddUserDialog.vue?vue&type=template&id=963906e0"
import script from "./AddUserDialog.vue?vue&type=script&lang=js"
export * from "./AddUserDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports